import React from "react";
import { Box, Button, Chip, useMediaQuery, useTheme } from "@mui/material";
import { Twitter as TwitterIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Logo from "./Logo";
import { trackLandingPageEvents } from "../utils/analytics";

const Header = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleLogoClick = () => {
    trackLandingPageEvents.logoClick();
    navigate("/");
  };

  const handleFollowClick = () => {
    trackLandingPageEvents.followClick();
    window.open("https://x.com/meme_for_real", "_blank");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        py: 3,
        mb: 4
      }}
    >
      <Box
        onClick={handleLogoClick}
        sx={{
          cursor: "pointer",
          "&:hover": {
            opacity: 0.8
          }
        }}
      >
        <Logo />
      </Box>
      <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        {!isMobile && (
          <Chip
            label="$MFR"
            sx={{
              background: "linear-gradient(45deg, #00ff00, #00cc00)",
              color: "#000",
              fontWeight: "bold",
              fontSize: "0.9rem"
            }}
          />
        )}
        <Button
          variant="outlined"
          size="small"
          startIcon={<TwitterIcon />}
          onClick={handleFollowClick}
          sx={{
            borderColor: "#00ff00",
            color: "#00ff00",
            fontSize: "0.8rem",
            py: 0.5,
            px: 1.5,
            minWidth: "auto",
            "&:hover": {
              borderColor: "#00ff00",
              background: "rgba(0, 255, 0, 0.1)"
            }
          }}
        >
          Follow
        </Button>
      </Box>
    </Box>
  );
};

export default Header;
